/// <reference path="../../../../typings/index.d.ts" />
///<reference path="../AppointmentBook/js/controllers/AppointmentBook.ts"/>
///<reference path="../../components/goals/goalBase.controller.ts"/>

module Meevo.Plugins.DepartmentGoal {
    'use strict';

    import GoalBaseController = Meevo.Components.Goals.GoalBaseController;
    import GoalCategoryEnum = Meevo.Components.Goals.GoalCategoryEnum;
    import GoalInputTypeEnum = Meevo.Components.Goals.GoalInputTypeEnum;
    import GoalViewEnum = Meevo.Components.Goals.GoalViewEnum;
    import IGoalBaseCriteria = Meevo.Components.Goals.IGoalBaseCriteria;
    import IGoalColumn = Meevo.Components.Goals.IGoalColumn;
    import IGoalRowLine = Meevo.Components.Goals.IGoalRowLine;
    import IGoalRowModel = Meevo.Components.Goals.IGoalRowModel;
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState;


    class DepartmentGoalController extends GoalBaseController {
        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        public editSecurityKey = this.securityKeys.GOALS_OVERALLDEPARTMENTGOALS + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
        public hideFilters: boolean = false;
        public goalsSlider: boolean = false;

        public departmentList: any = [
            {
                displayName: 'All Departments',
                id: 0
            }
        ];
        public filterCriteria: IGoalBaseCriteria = {
            criteria: {
                goalCategories: [],
                year: this.currentYear,
                departmentIds: [],
                view: GoalViewEnum.Default
            }
        };

        public baseCurrencyMaxValue = 9999999;

        init () {

            this.shortCutGroup = {
                [MaintenanceFormState.Readonly]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_EDIT',
                    callback: () => {
                        this.edit();
                    }
                }]),
                [MaintenanceFormState.Editing]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_SAVE',
                    callback: () => this.save()
                }, {
                    shortCutName: 'DATA_MAINTENANCE_CANCEL',
                    callback: () => this.cancel()
                }])
            };

            this.dataService.customMethodData(`${this.appSettings.API_ROOT}/department/List`, 'POST', null).then((res: any) => {
                _.each(res.data, (department: any) => {
                    this.departmentList.push(department);

                    if (department.id) {
                        this.departmentIdsList.push(department.id);
                    }
                });

                this.filterCriteria.criteria.departmentIds = this.departmentIdsList;
            });

        }
        public showFilters = () => {
            this.hideFilters = false;
        }
        /* Slide animation function */
        public sliderAnimation(): void {
            this.goalsSlider = !this.goalsSlider;
        }

        public getCategory(goalCategory) {
            switch (goalCategory) {
                case GoalCategoryEnum.AverageServiceTicket: { return 'LABEL_AVERAGE_TICKET' }
                case GoalCategoryEnum.FrequencyOfVisit: { return 'LABEL_FREQUENCY_OF_VISIT' }
                case GoalCategoryEnum.NewClientsPerMonth: { return 'LABEL_NEW_CLIENTS_PER_MONTH' }
                case GoalCategoryEnum.Rebook: { return 'LABEL_REBOOK' }
                case GoalCategoryEnum.Retail: { return 'LABEL_RETAIL' }
                case GoalCategoryEnum.NewClientRetention: { return 'LABEL_RETENTION' }
                case GoalCategoryEnum.Service: { return 'LABEL_SERVICE' }
                case GoalCategoryEnum.Rating: { return 'LABEL_5_STAR_RATING' }
                case GoalCategoryEnum.RequestRate: { return 'LABEL_REQUEST' }
                case GoalCategoryEnum.Membership: { return 'LABEL_MEMBERSHIP' }
                case GoalCategoryEnum.Productivity: { return 'LABEL_PRODUCTIVITY' }
                case GoalCategoryEnum.GiftCard: { return 'LABEL_GIFT_CARD_SALES' }
                default: {return null }
            }
        }

        public getMaxHeight = (workingdays = false, slideOpen = false, measurement = false) => {
            
            const element = angular.element(".goal-header--departmentHeader")[0].offsetHeight;
            let container = $('.goal-plugin').scope();
            let maxheight;
            switch (element) {
                case 0:
                    if (container.isMobileDevice) {
                        if (slideOpen) {
                            maxheight = 'calc(100% - 200px)';
                            break;
                        }
                        maxheight = 'calc(100% - 335px)'
                    }
                    else if (container.isPortrait && !container.isLargeTablet) {
                        maxheight = 'calc(100% - 235px)'
                    }
                    else {
                        maxheight = 'calc(100% - 180px)'
                    }
                    break;
                case 20:
                    if (container.isMobileDevice) {
                        maxheight = 'calc(100% - 135px)'
                    }
                    else if (container.isPortrait && !container.isLargeTablet) {
                        maxheight = 'calc(100% - 255px)'
                    }
                    else {
                        maxheight = 'calc(100% - 200px)'
                    }
                    break;
                case 40:
                    if (container.isMobileDevice) {
                        maxheight = 'calc(100% - 250px)'
                    }
                    else if (container.isPortrait && !container.isLargeTablet) {
                        maxheight = 'calc(100% - 275px)'
                    }
                    else {
                        maxheight = 'calc(100% - 220px)'
                    }
                case 75: {
                    if (container.isMobileDevice) {
                        if (workingdays && slideOpen) {
                            maxheight = 'calc(100% - 275px)';
                            break;
                        }
                        else if (workingdays) {
                            if (measurement) {
                                maxheight = 'calc(100% - 460px)';
                                break;
                            }
                            maxheight = 'calc(100% - 405px)';
                            break;
                        }
                        else if (slideOpen) {
                            maxheight = 'calc(100% - 240px)';
                            break;
                        }
                        else {
                            maxheight = 'calc(100% - 375px)';
                        }
                        
                    }
                    else {
                        maxheight = 'calc(100% - 255px)'

                    }
                }
                    break;
            }
            return maxheight;
        }


        /**
         * Saves the item currently being edited.
         */
        save(): angular.IPromise<any> {
            let goalCriteria = {
                    goals: []
                },
                goals = [],
                goalSaveRequest,
                inputType = this.getInputType();

            _.forEach(this.goalRowList, (department: IGoalRowModel) => {
                if (!department) return;

                _.forEach(department.rows, (year: IGoalRowLine) => {
                    if (!year) return;

                    _.forEach(year.columns, (item: IGoalColumn) => {
                        if (!item) return;

                        let goal = this.backupGoalList.find((elem) => {
                            if (((item.departmentId == 0 && !elem.id) || elem.id == item.departmentId) &&
                                elem.month == item.month &&
                                elem.year == item.year &&
                                elem.goalCategory == item.goalCategory) {
                                return elem;
                            }
                        });

                        if (inputType === GoalInputTypeEnum.Numeric) {
                            if (item.goalCategory === GoalCategoryEnum.FrequencyOfVisit) {
                                if (item.value != goal.amount) {
                                    item.amount = item.value ? item.value : 0;
                                    item.actualAmount = item.actualValue;

                                    goals.push(item);
                                }
                            } else if (item.goalCategory === GoalCategoryEnum.NewClientsPerMonth) {
                                if (item.value != goal.unit) {
                                    item.unit = item.value ? item.value : 0;
                                    item.actualUnit = item.actualValue;

                                    goals.push(item);
                                }
                            } else {
                                if (item.value != goal.unit) {
                                    item.unit = item.value;
                                    item.actualUnit = item.actualValue;

                                    goals.push(item);
                                }
                            }
                        } else if (inputType === GoalInputTypeEnum.Currency && (item.value != goal.amount)) {
                            item.amount = item.value;
                            item.actualAmount = item.actualValue;
                            goals.push(item);
                        } else if (inputType === GoalInputTypeEnum.Percentage && (item.value != goal.percent)) {
                            item.percent = item.value;
                            item.actualPercent = item.actualValue;
                            goals.push(item);
                        }else if (inputType === GoalInputTypeEnum.Float && (item.value != goal.amount)) {
                            item.amount = item.value;
                            item.actualAmount = item.actualValue;
                            goals.push(item);
                        }

                    });
                });
            });

            if (goals.length == 0) {
                goalSaveRequest = this.$q.defer();
                goalSaveRequest.reject(null);
                goalSaveRequest = goalSaveRequest.promise;
            } else {
				goalCriteria.goals = goals;
                goalSaveRequest = this.dataService.customMethodData(`${this.appSettings.API_ROOT}/Goal`, 'PUT', goalCriteria).then((res: any) => {
                    this.changeCriteriaFilter();
                });
            }

			this.showEdit = true;
			this.isReadonly = true;
            this._mode = MaintenanceFormState.Readonly;

            return goalSaveRequest;
        }

        /**
         * Request for goals list
         */
        changeCriteriaFilter() {
            this.busyService.start();
            this.goalRowList = {};
            this.goalRowArray = [];

            let filterCriteria = angular.copy(this.filterCriteria);
            if (this.goalCategory === GoalCategoryEnum.Rating) {
                filterCriteria.criteria['isHidden'] = null;
                filterCriteria.criteria['isDeleted'] = false;
            }

            this.dataService.customMethodData(`${this.appSettings.API_ROOT}/goal/List`, 'POST', filterCriteria).then((res: any) => {
                _.forEach(res.data, (el: any) => {
                    el.id = el.departmentId;
                });

                this.backupGoalList = angular.copy(res.data);
                this.goalRowList = this.formatGoals(res.data);
                this.updateTitle()
                
                this.busyService.stop();
                this.connectFloatingHeaders();
            });
        };

        updateTitle() {
            
            for (let key in this.goalRowList) {
                for (let date in this.goalRowList[key].rows) {
                    this.goalRowList[key].title = this.goalRowList[key].rows[date].title;
                    this.goalRowList[key].key = key;
                    this.goalRowArray.push(this.goalRowList[key])
                }
            }
            
        }

        changeItemColumn(itemRow) {
            if (this.isCountTotal) {
                this.countTotal(itemRow);
            }
        }

        changeTotalCallback(itemRow) {
            this.countTotalPerDay(itemRow);
        }

        changeDepartments(): void {
            this.filterCriteria.criteria.departmentIds = this.departmentId ? [this.departmentId] : this.departmentIdsList;

            this.changeCriteriaFilter();
        }

        setItemTitle(item, row) {
            let differenceYear = this.filterCriteria.criteria.year == item.year,
                department = _.findWhere(this.departmentList, { id: item.id });

            if (item.id == 0) {
                row.title = differenceYear ? 'Business Overall' : `Business Overall ${item.year}`;
            } else {
                if (department) {
                    if (differenceYear) {
                        let departmentCreationYear = Number(moment(department['dateCreated']).format("YYYY")),
                            date = moment(department['dateCreated']).format("ddd M/D/YY h:mm A");

                        row.title = department['displayName'];

                        if (this.filterCriteria.criteria.view == GoalViewEnum.ActualForLastYear && departmentCreationYear == this.currentYear) {
                            row.title = `${department['displayName']} ${date} <small>(Create Date)</small>`;
                        }
                    } else {
                        row.title = `${department['displayName']} ${item.year}`;
                    }
                }
            }

        };

        connectFloatingHeaders(): void {
            var container = $('#department-goal.goals-scrolling-container');
            container.scroll(function () {
                $('.employee-goal-headers').css({ "left": (container.scrollLeft() * -1) });
                $('.goal-background-mover').css({ "left": (container.scrollLeft() * 1) });
                $('.goal-component-row-titles').css({ "left": (container.scrollLeft()) });
            })
        }
    }

    angular.module('meevo.plugins.departmentGoal')
        .controller('meevo.plugins.departmentGoal.DepartmentGoalController', DepartmentGoalController);
}
